import { render } from "./PopularVtubersSection.vue?vue&type=template&id=25336a3c&scoped=true"
import script from "./PopularVtubersSection.vue?vue&type=script&lang=js"
export * from "./PopularVtubersSection.vue?vue&type=script&lang=js"

import "./PopularVtubersSection.vue?vue&type=style&index=0&id=25336a3c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-25336a3c"]])

export default __exports__